var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"transition-name":"notification-list","transition-mode":"out-in"}}),(_vm.showHeader)?_c('global-header'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath}),_c('global-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }